// extracted by mini-css-extract-plugin
export default {"loading-spinner":"LoadingSpinner_loading-spinner__8a-66","message":"LoadingSpinner_message__G9sCN"};